// extracted by mini-css-extract-plugin
module.exports = {"invalidationInfo":"InvalidationStatus_invalidationInfo__2qnz7"};